import styled, { css } from "styled-components";
import Link from "../../../Link";

export const MovementCell = styled.td`
  width: 16%;
`;

const boldStyles = css`
  color: ${({ theme }) => theme.colors.white1};
  font-weight: bold;
`;
export const StyledLink = styled(Link)`
  ${boldStyles}
`;

export const MovementHead = styled.th`
  width: 16%;
`;

export const RankHead = styled.th`
  width: 30%;
`;

export const NameHead = styled.th`
  width: 54%;
`;

export const Rank = styled.td`
  width: 30%;
  font-weight: 800;
`;

export const Name = styled.td`
  width: 54%;
  overflow-wrap: break-word;
  hyphens: auto;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[4]};
`;

export const NoCupsWrap = styled.div`
  margin: ${({ theme }) => theme.space[2]};
`;
